import {getQueueCount, outQueue} from "./queue.js";

let isQueueRunning = false;

function observePopup({target, callback}, next) {
    const closeObserver = new MutationObserver(async (mutationsList, thisObserver) => {
        let oneCountFlag = true;
        for (const mutation of mutationsList) {
            const isAttr = mutation.type === 'attributes';
            const isStyle = mutation.attributeName === 'style';
            const isInvisible = mutation.target.style.display === 'none';

            if ((isAttr && isStyle && isInvisible) && oneCountFlag) {
                if (getQueueCount() > 0) {
                    next();
                } else {
                    isQueueRunning = false;
                }
                oneCountFlag = false;
                await thisObserver.disconnect();
            }
        }
    });

    isQueueRunning = true;

    // 브라우저에서 띄우는 외부 팝업일 경우 callback 함수 호출 후 return
    if(target === "browserPopup") {
        callback();
        return;
    }

    const $target = document.querySelector(target);
    callback();

    closeObserver.observe($target, {
        attributes: true,
        attributeFilter: ['style'],
        childList: true,
        subtree: true
    });
}

function nextQueue() {
    observePopup(outQueue(), nextQueue);
}

function getQueueRunStatus() {
    return JSON.parse(JSON.stringify(isQueueRunning));
}

export {observePopup, nextQueue, getQueueRunStatus}
